import {Step} from '@softline/application';

export const SOFTLINE_PERMISSION_PRUEFPROTOKOLL = 'PRUEFPROTOKOLL';

export const SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL = 'produktion/pruefprotokoll';
export const SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL_ERSTELLEN = 'produktion/pruefprotokoll/erstellen';
export const SOFTLINE_FEATURE_PRODUKTION_PRUEFPROTOKOLL_AKTIVITAETEN = 'produktion/pruefprotokoll/aktivitaeten';

export const SOFTLINE_CONFIG_PRUEFPROTOKOLL_STEPS: Step[] = [
  {
    header: '#PRUEFPROTOKOLL.STEPS.STEP_01.HEADER',
    subHeader: '#PRUEFPROTOKOLL.STEPS.STEP_01.SUBHEADER'
  },
  {
    header: '#PRUEFPROTOKOLL.STEPS.STEP_02.HEADER',
    subHeader: '#PRUEFPROTOKOLL.STEPS.STEP_02.SUBHEADER'
  },
  {
    header: '#PRUEFPROTOKOLL.STEPS.STEP_03.HEADER',
    subHeader: '#PRUEFPROTOKOLL.STEPS.STEP_03.SUBHEADER'
  }
]
